import {
	Box,
	FormControl,
	FormHelperText,
	InputLabel,
	Link,
	OutlinedInput,
	Typography,
} from '@mui/material';
import { FC } from 'react';
import { CountrySelectMenu } from 'ui/CountrySelectMenu';
import { TStep4Props } from './types';

export const Step4: FC<TStep4Props> = ({
	setHsCode,
	hsCode,
	setSelectedCountry,
	selectedCountry,
}) => {
	return (
		<>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					// alignItems: 'center',
					// justifyContent: 'center',
					mt: '20px',
					gap: '40px',
					pb: '20px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						backgroundColor: '#0092de24',
						borderRadius: '12px',
						p: '20px',
						// mt: '20px',
						width: 'calc(100%)',
					}}
				>
					<Typography
						sx={{
							fontSize: '3rem',
							color: '#016193',
							fontFamily: 'monospace',
							mr: 2,
							mt: -1,
							mb: -2,
							fontWeight: 'bold',
							textTransform: 'lowercase',
						}}
					>
						i
					</Typography>
					<Box>
						<Typography
							component="p"
							sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
						>
							For proper VAT rates selection to be provided warehouse country and Harmonised System
							(HS) code of the products.
						</Typography>
						<Typography
							component="p"
							sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
						>
							An HS code is an international trade code, usually six digits long, that&apos;s used
							to describe what a product is.{' '}
						</Typography>
						<Typography
							component="p"
							sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
						>
							You can get HS code from&nbsp;
							<Link
								href="https://easproject.com/eu-customs-tariffs-guide/"
								target="_blank"
								rel="noreferrer"
								sx={{
									color: '#016193',
									fontSize: '1rem',
									fontWeight: 'bold',
									textDecoration: 'none',
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								EAS EU Tariffs Guide
							</Link>
						</Typography>
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					justifyContent: 'space-between',
					width: '100%',
					gap: '20px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'left',
						gap: '20px',
						width: '100%',
					}}
				>
					<FormControl size="small" sx={{ width: '100%' }}>
						<InputLabel htmlFor="hs-code">HS Code</InputLabel>
						<OutlinedInput
							id="hs-code"
							label="HS Code"
							sx={{
								borderRadius: '12px',
							}}
							// variant="outlined"
							size="small"
							value={hsCode}
							onChange={(e) => setHsCode(e.target.value)}
						/>
						<FormHelperText id="api-key-helper-text">
							this field may be left empty, in that case standard rates will be applied
						</FormHelperText>
					</FormControl>
				</Box>
			</Box>
			{/* <Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					// alignItems: 'center',
					// justifyContent: 'center',
					mt: '20px',
					gap: '40px',
					pb: '20px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						backgroundColor: '#0092de24',
						borderRadius: '12px',
						p: '20px',
						// mt: '20px',
						width: 'calc(100%)',
					}}
				>
					<Typography
						sx={{
							fontSize: '3rem',
							color: '#016193',
							fontFamily: 'monospace',
							mr: 2,
							mt: -1,
							mb: -2,
							fontWeight: 'bold',
							textTransform: 'lowercase',
						}}
					>
						i
					</Typography>
					<Box>
						<Typography
							component="p"
							sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
						>
							Please choose the country from which the products will be dispatched.
						</Typography>
					</Box>
				</Box>
			</Box> */}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'left',
					gap: '20px',
					width: '100%',
					mt: '20px',
				}}
			>
				<FormControl size="small" sx={{ width: '100%' }}>
					<CountrySelectMenu onChange={setSelectedCountry} countryCode={selectedCountry} />
					<FormHelperText id="api-key-helper-text">
						please choose the country from which the products will be dispatched
					</FormHelperText>
				</FormControl>
			</Box>
		</>
	);
};
